import { Card } from "@/shared/ui/card"

import withLoading from "@/shared/hooks/withLoading"

/**
 * A Card component with built-in loading state functionality
 */
const LoadingCard = withLoading(Card, {
  // Default overlay styling options
  backdropClassName: "bg-gray-900/30",
  spinnerColor: "text-yellow-500"
})

export default LoadingCard
